/* Spegne il segnaposto col marchio quando l'immagine prodotto arriva.

   Serve perche' il CSS da solo non sa distinguere "immagine non ancora
   caricata" da "immagine caricata": senza questo, dietro una foto
   scontornata il marchio resterebbe visibile per sempre. Le foto
   verificate sono opache, ma il catalogo ha seimila referenze da
   fornitori diversi e non si puo' garantirlo per tutte.

   L'evento `load` delle immagini non risale il DOM, quindi si ascolta in
   fase di cattura sul documento: una sola registrazione copre anche le
   immagini che arrivano dopo, comprese quelle a caricamento differito e
   quelle iniettate dalla paginazione. */
(function () {
  'use strict';

  function segna(img) {
    var media = img.closest && img.closest('.media');
    if (media) media.classList.add('media--caricata');
  }

  document.addEventListener(
    'load',
    function (e) {
      var t = e.target;
      if (t && t.tagName === 'IMG') segna(t);
    },
    true
  );

  /* Le immagini gia' in cache possono essere complete prima che questo
     script giri: l'evento non scatterebbe mai e il segnaposto resterebbe
     acceso sotto un'immagine gia' visibile. */
  function recupera() {
    var imgs = document.querySelectorAll('.media img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].complete && imgs[i].naturalWidth > 0) segna(imgs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', recupera, { once: true });
  } else {
    recupera();
  }
})();
